import { dynamic } from '#/utils/dynamic';

export const staffGradFairModalComponentByType = {
  STAFF_GRAD_FAIR_REGISTER: dynamic(
    () =>
      import('./Register/StaffGradFairRegisterModal').then((module) => ({
        default: module.StaffGradFairRegisterModal,
      })),
    { strategy: 'always' },
  ),
  STAFF_GRAD_FAIR_CANCEL_REGISTRATION: dynamic(
    () =>
      import('./CancelRegistration/StaffGradFairCancelRegistrationModalContainer').then(
        (module) => ({
          default: module.StaffGradFairCancelRegistrationModalContainer,
        }),
      ),
    { strategy: 'always' },
  ),
  STAFF_GRAD_FAIR_SPONSOR_OR_HOST: dynamic(
    () =>
      import('./RegistrationSponsorOrHost/StaffGradFairRegistrationSponsorOrHostModal').then(
        (module) => ({
          default: module.StaffGradFairRegistrationSponsorOrHostModal,
        }),
      ),
    { strategy: 'always' },
  ),
  STAFF_GRAD_FAIR_ADD_TO_WAITLIST: dynamic(
    () =>
      import('./AddToWaitlist/StaffGradFairAddToWaitlistModal').then(
        (module) => ({ default: module.StaffGradFairAddToWaitlistModal }),
      ),
    { strategy: 'always' },
  ),
  STAFF_GRAD_FAIR_INVITE: dynamic(
    () =>
      import('./Invite/StaffGradFairInviteModal').then((module) => ({
        default: module.StaffGradFairInviteModal,
      })),
    { strategy: 'always' },
  ),
  STAFF_GRAD_FAIR_REMOVE_FROM_WAITLIST: dynamic(
    () =>
      import('./RemoveFromWaitlist/StaffGradFairRemoveFromWaitlistModal').then(
        (module) => ({ default: module.StaffGradFairRemoveFromWaitlistModal }),
      ),
    { strategy: 'always' },
  ),
} as const satisfies Record<string, unknown>;
